import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Events from "../pages/events/page";
import EventDetail from "../pages/event/page";
import CategoryDetail from "../pages/category/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/event/:slug",
    element: <EventDetail />,
  },
  {
    path: "/category/:slug",
    element: <CategoryDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;